import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { ChartModule } from '../chart/chart.module';
import { ChipsListModule } from '../chips-list/chips-list.module';
import { DrilldownChartNoDataAvailableModule } from '../drilldown-chart-no-data-available/drilldown-chart-no-data-available.module';
import { DrilldownTableModule } from '../drilldown-table/drilldown-table.module';
import { DrilldownChartToggleModule } from '../drilldown-toggle-chart/drilldown-toggle-chart.module';
import { GroupedBarChartModule } from '../grouped-bar-chart/grouped-bar-chart.module';
import { TrendChartModule } from '../trend-chart/trend-chart.module';
import { ExpandedViewComponent } from './expanded-view.component';

@NgModule({
  declarations: [ExpandedViewComponent],
  imports: [
    MatDialogModule,
    ChipsListModule,
    ChartModule,
    TrendChartModule,
    DrilldownChartNoDataAvailableModule,
    DrilldownTableModule,
    CommonModule,
    DrilldownChartToggleModule,
    GroupedBarChartModule,
    MatIconModule
  ],
  exports: [ExpandedViewComponent],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ExpandedViewModule {}
